<template>
    <CCard class="mb-0 h-100" v-show="!storePageLoading">
        <CCardHeader>
            <!-- Title page  -->
            <h1 class="page__title">{{ $t(titlePage) }}</h1>
        </CCardHeader>
        <CCardBody class="main-card-body">
            <CContainer fluid class="p-0">
                <CRow class="justify-content-end p-2 m-0">
                    <CCol md="5">
                        <!-- Filter -->
                        <FilterDate @updateData="updateData" />
                    </CCol>
                </CRow>
                <CRow class="p-2 m-0">
                    <CCol md="12" sm="12">
                        <!-- Filter -->
                        <FilterFields
                            :fields="tables.GroupMemberLeadsTable.fields"
                            @filter="updateData"
                        />
                    </CCol>
                </CRow>
                <CRow>
                    <CCol xl="12" md="12" class="mb-4">
                        <CCard>
                            <CCardHeader>
                                <!-- Button back -->
                                <div class="d-flex">
                                    <ButtonBack class="mr-3" />
                                    <TableSettings
                                        :allFields="
                                            tables.GroupMemberLeadsTable
                                                .allFields
                                        "
                                        :activeFields.sync="
                                            tables.GroupMemberLeadsTable.fields
                                        "
                                    />
                                </div>
                            </CCardHeader>
                            <CCardBody>
                                <h6>
                                    {{ $t("leads_received_description") }}
                                </h6>
                                <CDataTable
                                    :addTableClasses="['table--sm']"
                                    :items="tables.GroupMemberLeadsTable.items"
                                    :fields="
                                        traslateArrayObjects({
                                            array: tables.GroupMemberLeadsTable
                                                .fields,
                                            fields: ['label'],
                                        })
                                    "
                                    :columnFilterValue.sync="
                                        tables.GroupMemberLeadsTable
                                            .columnFilterValue
                                    "
                                    @update:column-filter-value="updateData()"
                                    @update:sorter-value="updateData()"
                                    @pagination-change="itemPerPage"
                                    :items-per-page="
                                        tables.GroupMemberLeadsTable.rows
                                    "
                                    v-bind="tables.GroupMemberLeadsTable"
                                >
                                    <template #over-table> </template>
                                    <template #under-table>
                                        <div class="d-flex justify-content-end">
                                            <ButtonExport
                                                :endPoint="
                                                    `/shipment.balancing.api/client-groups/${group}/members/${member}/leads/pagination`
                                                "
                                                :table="
                                                    tables.GroupMemberLeadsTable
                                                "
                                            />
                                        </div>
                                    </template>
                                </CDataTable>
                            </CCardBody>
                            <CCardFooter
                                v-if="
                                    tables.GroupMemberLeadsTable.total_pages > 0
                                "
                            >
                                <div class="position-relative">
                                    <CPagination
                                        @update:activePage="updatePagination"
                                        :activePage="
                                            tables.GroupMemberLeadsTable.page
                                        "
                                        :pages="
                                            tables.GroupMemberLeadsTable
                                                .total_pages
                                        "
                                        align="center"
                                    />
                                    <CElementCover
                                        :opacity="0.8"
                                        class="bg-trasparent"
                                        v-if="
                                            tables.GroupMemberLeadsTable.loading
                                        "
                                    />
                                </div>
                            </CCardFooter>
                        </CCard>
                    </CCol>
                </CRow>
            </CContainer>
        </CCardBody>
    </CCard>
</template>

<script>
/**
 * Components
 */
import TableSettings from "£lement/TableSettings";
import FilterDate from "~/components/FilterDate";
import FilterFields from "~/components/FilterFields";
import ButtonExport from "~/components/ButtonExport";
import ButtonBack from "£lement/ButtonBack";

/** Mixins */
import tableMixin from "~/mixins/table.js";
import pageMixin from "~/mixins/page.js";

/** Others */
import {
    cilPlus,
    cilSettings,
    cilPencil,
    cilTrash,
    cilArrowThickFromRight,
} from "@coreui/icons";
import { mapGetters } from "vuex";
import GroupMemberLeadsTable from "./config/tables/GroupMemberLeads";

export default {
    name: "DeliveryCampaignGroupMemberLeadsPage",
    middleware: ["auth", "page"],
    mixins: [pageMixin, tableMixin],
    components: {
        FilterDate,
        FilterFields,
        TableSettings,
        ButtonBack,
        ButtonExport,
    },
    icons: {
        cilPlus,
        cilSettings,
        cilPencil,
        cilTrash,
        cilArrowThickFromRight,
    },
    data() {
        return {
            tables: {
                GroupMemberLeadsTable: GroupMemberLeadsTable,
            },
        };
    },
    computed: {
        ...mapGetters({
            from: "filter/from",
            to: "filter/to",
        }),

        group: function () {
            return this.$route.params.group;
        },
        member: function () {
            return this.$route.params.member;
        },
    },
    methods: {
        async updateData() {
            await this.updateTable({
                tableName: "GroupMemberLeadsTable",
                url: `/shipment.balancing.api/client-groups/${this.group}/members/${this.member}/leads/pagination`,
            });

            this.tables.GroupMemberLeadsTable.allFields =
                this.getTableAllFields("GroupMemberLeadsTable");
            this.$store.dispatch("page/updateLoading", {
                loading: false,
            });
        },
    },
    mounted() {
        this.updateData({
            from: this.from,
            to: this.to,
        });
    },
};
</script>

<style scoped lang="scss"></style>
